import {
  addDepPosition,
  deletePositionInfo,
  getDepartmentList,
  getPersonDesensitizeDetail,
  getPersonDetail,
  getPersonList,
  getUserSearchPersonDesensitizeDetail,
  getUserSearchPersonDetail,
  getUserTypeList,
  listOrgClueParent,
  modifyInfo,
  modifyPositionInfo,
  switchStatus,
} from '../services/index';

export default {
  namespace: 'PersonnelManagement',
  state: {},
  effects: {
    // 获取人员表格数据
    *GetPersonList({ payload }, { call }) {
      return yield call(getPersonList, payload);
    },
    // 获取人员详情--脱敏
    *GetPersonDetail({ payload }, { call }) {
      return yield call(getPersonDetail, payload);
    },
    // 获取人员详情--不脱敏
    *GetPersonDesensitizeDetail({ payload }, { call }) {
      return yield call(getPersonDesensitizeDetail, payload);
    },
    // 获取人员详情--脱敏
    *GetUserSearchPersonDetail({ payload }, { call }) {
      return yield call(getUserSearchPersonDetail, payload);
    },
    // 获取人员详情--不脱敏
    *GetUserSearchPersonDesensitizeDetail({ payload }, { call }) {
      return yield call(getUserSearchPersonDesensitizeDetail, payload);
    },

    // 获取机构列表包含父级
    *listOrgClueParent({ payload }, { call }) {
      const res = yield call(listOrgClueParent, payload);
      return res.result || [];
    },
    // 删除人员的部门任职信息
    *DeletePositionInfo({ payload }, { call }) {
      return yield call(deletePositionInfo, payload);
    },
    // 修改人员的部门任职信息
    *ModifyPositionInfo({ payload }, { call }) {
      return yield call(modifyPositionInfo, payload);
    },
    // 修改人员的部GetPersonDetail门任职信息
    *ModifyInfo({ payload }, { call }) {
      return yield call(modifyInfo, payload);
    },
    // 修改人员的部门任职信息
    *GetDepartmentList({ payload }, { call }) {
      return yield call(getDepartmentList, payload);
    },
    // 修改人员的部门任职信息
    *SwitchStatus({ payload }, { call }) {
      return yield call(switchStatus, payload);
    },

    // 新建一个职位
    *AddDepPosition({ payload }, { call }) {
      return yield call(addDepPosition, payload);
    },

    // 查询嘉兴公安配置信息
    *getUserTypeList({ payload }, { call }) {
      return yield call(getUserTypeList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
